export const softHyphenSupport = (value) => {
  if (!value) {
    return '';
  }
  const values = value.split('&shy;');
  return values
    .reduce((res, item) => res.concat(item, <>&shy;</>), [])
    .slice(0, -1);
};
